import { CircularProgress } from '@material-ui/core';
import React from 'react';

export const SmallCircularProgress = () => <CircularProgress size={20} color="primary" />;

export default SmallCircularProgress;
